/**
 * 方便使用vue的类. 硬性规定: 
 * 1. 正在显示的属性必须命名为active
 */

import OSS from 'ali-oss';
import { uuid } from 'vue-uuid';

export function getItemById(items, itemId){
    for(let i=0; i < items.length; i++){
        if(items[i].id == itemId){
            return items[i];
        }
    }    
}

export function getIndexOfItem(items, itemId){
  
    for(let i=0; i < items.length; i++){
        if(items[i].id == itemId){
            return i;
        }
    }      
}

export function getItemActive(items){
  
    for(let i=0; i < items.length; i++){
        if(items[i].active){
            return items[i];
        }
    }      
}

export function setItemActive(items, itemId){
  
    for(let i=0; i < items.length; i++){
        if(items[i].id == itemId){
            items[i].active = true;
        }
        else{
            items[i].active = false;
        }
    }     
}

export function makeSearchParams(params){

    let urlParams = new URLSearchParams(); 
    if(params instanceof Object){
        for(var p in params){
            urlParams.append(p, params[p]);
        }
    }
    else{
        urlParams = params;
    }
    return urlParams;
}

export function format_now_to_hhmmss () {
    var datetime = new Date();
    //var month = datetime.getMonth() + 1 < 10 ? "0" + (datetime.getMonth() + 1) : datetime.getMonth() + 1;
    //var date = datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime.getDate();
    var hour = datetime.getHours()< 10 ? "0" + datetime.getHours() : datetime.getHours();
    var minute = datetime.getMinutes()< 10 ? "0" + datetime.getMinutes() : datetime.getMinutes();
    var second = datetime.getSeconds()< 10 ? "0" + datetime.getSeconds() : datetime.getSeconds();
    return hour+":"+minute+":"+second;
}

// 转换为yyyy-MM-dd hh:mm:ss
export function format_date_1 (date) {
    
			if (date == undefined) {
				return "";
            }
            let d = new Date(date);
			// return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() ;

			// return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' '+d.getHours() + ':' + d.getMinutes()  + ':' + d.getSeconds();
			return dateTimeFormat(d);

}


//時間格式化
export function dateTimeFormat(time) {
    if(time){
        time = new Date(time);
        var y = time.getFullYear();
        var m = time.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = time.getDate();
        d = d < 10 ? ('0' + d) : d;
        var h = time.getHours();
        h = h < 10 ? ('0'+ h) : h;
        var mm = time.getMinutes();
        mm = mm < 10 ? ('0'+ mm) : mm;
        var s = time.getSeconds();
        s = s < 10 ? ('0'+ s) : s;
        // var result = y + '-' + m + '-' + d +  ' ' + h + ':' + mm + ':' + s;
        // return result.replace(/[ ]/g,'\r\n');
        return y + '-' + m + '-' + d +  ' ' + h + ':' + mm + ':' + s;
    }else{
        return '';
    }
}
//時間格式化类型 2010/10/23 15:12:25
export function dateTimeFormatL(time) {
    if(time){
        time = new Date(time);
        var y = time.getFullYear();
        var m = time.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = time.getDate();
        d = d < 10 ? ('0' + d) : d;
        var h = time.getHours();
        h = h < 10 ? ('0'+ h) : h;
        var mm = time.getMinutes();
        mm = mm < 10 ? ('0'+ mm) : mm;
        var s = time.getSeconds();
        s = s < 10 ? ('0'+ s) : s;
        // var result = y + '-' + m + '-' + d +  ' ' + h + ':' + mm + ':' + s;
        // return result.replace(/[ ]/g,'\r\n');
        return y + '/' + m + '/' + d +  ' ' + h + ':' + mm + ':' + s;
    }else{
        return '';
    }
}


//時間格式化
export function dateFormat(time) {
    var y = time.getFullYear();
    var m = time.getMonth() + 1;
    m = m < 10 ? ('0' + m) : m;
    var d = time.getDate();
    d = d < 10 ? ('0' + d) : d;

    return y + '-' + m + '-' + d;
}
//日期转化成字符串
export function formatDate (time) {
    if(time){
        let date = new Date(time);
        var y = date.getFullYear();  
        var m = date.getMonth() + 1;  
        m = m < 10 ? ('0' + m) : m;  
        var d = date.getDate();  
        d = d < 10 ? ('0' + d) : d;  
        return y + '-' + m + '-' + d; 
    }else{
        return '';
    }
}

export function EchartsformatDate (time) {
    if(time){
        let date = new Date(time); 
        var m = date.getMonth() + 1;  
        // m = m < 10 ? ('0' + m) : m;  
        var d = date.getDate();  
        d = d < 10 ? ('0' + d) : d;  
        return  m + '月' + d + '日'; 
    }else{
        return '';
    }
}

// 转换为yyyy-MM-dd
export function formatDataYYYYmmdd (date) {
    
    if (date == undefined) {
        return "";
    }
    let d = new Date(date);
    return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() ;

}

// 转换为yyyy-MM-dd hh:mm
export function formatStringToYYYYmmddhhmm (date) {
    
    if (date == undefined) {
        return "";
    }
    let d = new Date(date);
    return dateTimeFormat(d);

}

// 返回 当天时间的 yyyy-mm-dd 的字符串
export function get_today_str () {

    let date = new Date();

    var year = date.getFullYear();

    var month = (1 + date.getMonth()).toString();
    month = month.length > 1 ? month : '0' + month;

    var day = date.getDate().toString();
    day = day.length > 1 ? day : '0' + day;
  
    return year + '-' + month + '-' + day;
 
}

// 检查鼠标是否落在某个物体( div, 其他对象... )
export function isMouseInObject(event, checkDiv){
    
    let X = event.clientX;
    let Y = event.clientY;
    let isIn = false;
    let checkDistance = 5;   // 5px;

    let offsetLeft = checkDiv.offsetLeft;
    let offsetTop = checkDiv.offsetTop;
    let offsetWidth = checkDiv.offsetWidth;
    let offsetHeight = checkDiv.offsetHeight;

    // console.log('==== X: ' + X);
    // console.log('==== Y: ' + Y);

    // 纵向检查
    if( Y < offsetTop || Y > (offsetTop + offsetHeight) ){
        // console.log('==== offsetTop: ' + offsetTop);
        // console.log('==== boxHeight: ' + (offsetTop + offsetHeight));
        isIn = false;
    }
    else{
        // 纵向Y 满足, 检查 X
        // console.log('==== offsetLeft: ' + offsetLeft);
        // console.log('==== boxWidth: ' + (offsetLeft + offsetWidth));

        if( X < offsetLeft ||  X > (offsetLeft + offsetWidth)){
            isIn = false;
        }
        else{
            isIn = true;
        }
    }

    return isIn;
}

// 设置所有属性
export function batchSetProp(items, prop, value){
  
    for(let i=0; i < items.length; i++){
        items[i][prop] = value;
    }      
}

// 根据属性的值 找出 item
export function getItemBy(items, propName, propValue){
    for(let i=0; i < items.length; i++){
        if(items[i][propName] == propValue){
            return items[i];
        }
    }    
}

// clone list. 默认赋值一级参数. 如果要更多定制, 自己传入 clone_func
export function cloneList(dataList, clone_func){
    let newlist = []
    for(let i=0; i < dataList.length; i++){
        let from  = dataList[i];
        let to = {};
        
        if(clone_func){
            clone_func(from, to);
        }
        else{
            for(var x in from){
                to[x] = from[x];
            }
        }
        newlist.push(to);
    }    
    return newlist;
}

export function getIdList(dataList){
    let newlist = []
    for(let i=0; i < dataList.length; i++){
        let from  = dataList[i];
        newlist.push(from.id);
    }    
    return newlist;
}

// 从列表删除一条数据
// 这里作个代码备份, 因为我老记不住删除的api. 
// export function deleteEach(dataList, theIndex){
//     dataList.splice(theIndex, 1); 
// }

// 将对象的属性值设置为空字符串
export function setPropValueToEmpty(obj){

    if(!obj)return;
   
    for(var p in obj){
        obj[p] = '';
    }    
}

// 检查是否函数
export function isFunction(obj){

    if(!obj)return false;
   
    return typeof(obj) == 'function';  
}

//将金额转换为大写
export function convertCurrency(money) {
    //汉字的数字
    var cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖');
    //基本单位
    var cnIntRadice = new Array('', '拾', '佰', '仟');
    //对应整数部分扩展单位
    var cnIntUnits = new Array('', '万', '亿', '兆');
    //对应小数部分单位
    var cnDecUnits = new Array('角', '分', '毫', '厘');
    //整数金额时后面跟的字符
    var cnInteger = '整';
    //整型完以后的单位
    var cnIntLast = '元';
    //最大处理的数字
    var maxNum = 999999999999999.9999;
    //金额整数部分
    var integerNum;
    //金额小数部分
    var decimalNum;
    //输出的中文金额字符串
    var chineseStr = '';
    //分离金额后用的数组，预定义
    var parts;
    if (money === '') { //不能用==
        return '';
    }
    money = parseFloat(money);
    if (money >= maxNum) {
        //超出最大处理数字
        return '';
    }
    if (money == 0) {
        chineseStr = cnNums[0] + cnIntLast + cnInteger;
        return chineseStr;
    }
    //转换为字符串
    money = money.toString();
    if (money.indexOf('.') == -1) {
        integerNum = money;
        decimalNum = '';
    } else {
        parts = money.split('.');
        integerNum = parts[0];
        decimalNum = parts[1].substr(0, 4);
    }
    //获取整型部分转换
    if (parseInt(integerNum, 10) > 0) {
        var zeroCount = 0;
        var IntLen = integerNum.length;
        for (var i = 0; i < IntLen; i++) {
            var n = integerNum.substr(i, 1);
            var p = IntLen - i - 1;
            var q = p / 4;
            var m = p % 4;
            if (n == '0') {
                zeroCount++;
            } else {
                if (zeroCount > 0) {
                    chineseStr += cnNums[0];
                }
                //归零
                zeroCount = 0;
                chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
            }
            if (m == 0 && zeroCount < 4) {
                chineseStr += cnIntUnits[q];
            }
        }
        chineseStr += cnIntLast;
    }
    //小数部分
    if (decimalNum != '') {
        var decLen = decimalNum.length;
        for (var i = 0; i < decLen; i++) {
            var n = decimalNum.substr(i, 1);
            if (n != '0') {
                chineseStr += cnNums[Number(n)] + cnDecUnits[i];
            }
        }
    }
    if (chineseStr == '') {
        chineseStr += cnNums[0] + cnIntLast + cnInteger;
    } else if (decimalNum == '') {
        chineseStr += cnInteger;
    }
    return chineseStr;
}



//加 
export function floatAdd(arg1,arg2){ 
    var r1,r2,m; 
    try{r1=arg1.toString().split(".")[1].length}catch(e){r1=0} 
    try{r2=arg2.toString().split(".")[1].length}catch(e){r2=0} 
    m=Math.pow(10,Math.max(r1,r2)); 
    return (arg1*m+arg2*m)/m; 
  } 
     
  //减 
  export function floatSub(arg1,arg2){ 
   var r1,r2,m,n; 
   try{r1=arg1.toString().split(".")[1].length}catch(e){r1=0} 
   try{r2=arg2.toString().split(".")[1].length}catch(e){r2=0} 
   m=Math.pow(10,Math.max(r1,r2)); 
   //动态控制精度长度 
   n=(r1>=r2)?r1:r2; 
   return ((arg1*m-arg2*m)/m).toFixed(n); 
  } 
     
  //乘 
  export function floatMul(arg1,arg2) { 
   var m=0,s1=arg1.toString(),s2=arg2.toString(); 
   try{m+=s1.split(".")[1].length}catch(e){} 
   try{m+=s2.split(".")[1].length}catch(e){} 
   return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m); 
  } 
     
     
  //除 
  export function floatDiv(arg1,arg2){ 
    var t1=0,t2=0,r1,r2; 
    try{t1=arg1.toString().split(".")[1].length}catch(e){} 
    try{t2=arg2.toString().split(".")[1].length}catch(e){} 
      
    r1=Number(arg1.toString().replace(".","")); 
    
    r2=Number(arg2.toString().replace(".","")); 
    return (r1/r2)*Math.pow(10,t2-t1); 
  }


  /**
   * 通过出生日期得到年龄
* @param strBirthday：指的是出生日期，格式为"1990-01-01"
*/
  export function getAgeByBirthday(strBirthday){       
    var returnAge,
   		strBirthdayArr=strBirthday.split("-"),
    	birthYear = strBirthdayArr[0],
    	birthMonth = strBirthdayArr[1],
    	birthDay = strBirthdayArr[2],  
   	 	d = new Date(),
    	nowYear = d.getFullYear(),
    	nowMonth = d.getMonth() + 1,
    	nowDay = d.getDate();   
    if(nowYear == birthYear){
        returnAge = 0;//同年 则为0周岁
    }
    else{
        var ageDiff = nowYear - birthYear ; //年之差
        if(ageDiff > 0){
            if(nowMonth == birthMonth) {
                var dayDiff = nowDay - birthDay;//日之差
                if(dayDiff < 0) {
                    returnAge = ageDiff - 1;
                }else {
                    returnAge = ageDiff;
                }
            }else {
                var monthDiff = nowMonth - birthMonth;//月之差
                if(monthDiff < 0) {
                    returnAge = ageDiff - 1;
                }
                else {
                    returnAge = ageDiff ;
                }
            }
        }else {
            returnAge = -1;//返回-1 表示出生日期输入错误 晚于今天
        }
    } 
    return returnAge;//返回周岁年龄
}

//金额格式化
export function amountFormat(value) {
    if(!value) return '0.00';
    let result = 0;
    if(typeof value == 'string'){
        result = parseFloat(value).toFixed(2);
        // if(typeof result !=Number){    
        //     return value;
        // }
    }else{
        result = value.toFixed(2);
        
    }

    var value2Array = result.split(".");
    var intPart = value2Array[0];
    var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断
    var floatPart = ".00";
    floatPart = value2Array[1];
    return intPartFormat + '.' + floatPart;
}

//计算日期相减天数
export function checkDay(date) {
    let [t1, t2] = date;
    let startTime = new Date(t1);
    let endTime = new Date(t2);
    let days = endTime.getTime() - startTime.getTime();
    let day = parseInt(days / (1000 * 60 * 60 * 24));
    return day;
}

export function subStringNum(a,num) {
    var a_type = typeof(a);
    if(a_type == "number"){
        var aStr = a.toString();
        var aArr = aStr.split('.');
    }else if(a_type == "string"){
        var aArr = a.split('.');
    }

    if(aArr.length > 1) {
        a = aArr[0] + "." + aArr[1].substr(0, num);
    }
    return a
}

//根据字宽计算宽度
export function floatWidth(val, width) {
    let res = subStringNum(floatDiv(val, 10000), 2).toString().length;
    return (res * width) < 40 ? 40 : res * width;
}

// cdn 引入echarts
export async function loadScript(url, id) {
    return new Promise((resolve, reject) => {
        if (document.querySelector(`#${id}`)) {
            resolve('');
            return;
        }
        const script = document.createElement('script');
        script.id = id || `${Date.now()}`;
        script.onload = () => resolve('');
        script.onerror = () => {
        script.parentNode.removeChild(script);
            reject();
        };
        script.src = url;
        document.body.appendChild(script);
    });
}

// base64 上传到 oss
function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1], bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, {type: mime});
}

export function uploadBase64(base64, filename, cb) {
    const content = dataURLtoFile(base64, filename);
    console.log(content)

    const client = new OSS({
        region: 'oss-cn-shenzhen',
        accessKeyId: 'LTAI4GGHb3kkSnv9MdPdPb4Y',
        accessKeySecret: 'yEOrbRYDSIJpgjGiZk9yTsuSAyava9',
        bucket: 'xmoty',
        timeout: 600000
    });

    const nowDate = new Date();
    const date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        date: nowDate.getDate(),
    }

    /*文件名加时间戳*/
    const _month = date.month < 10 ? '0'+date.month : date.month
    const _date = date.date < 10 ? '0'+date.date : date.date
    const rnum = uuid.v1();
    const fileName = rnum;

    /*截取文件类型*/ 
    const fileType = (content.name).slice((content.name).lastIndexOf('.')+1,content.name.length);
    const fileDir = 'xmerp/xmfiles/'+ date.year + '/' + _month + '/' + _date + '/' + fileName + '.' + fileType;
    async function putObject() {
        try {
            // 填写Object完整路径。Object完整路径中不能包含Bucket名称。
            // 您可以通过自定义文件名（例如exampleobject.txt）或文件完整路径（例如exampledir/exampleobject.txt）的形式实现将数据上传到当前Bucket或Bucket中的指定目录。
            // data对象可以自定义为file对象、Blob数据或者OSS Buffer。
            const result = await client.put(fileDir, content);
            cb(result);
        } catch (e) {
            console.log(e);
        }
    }
    putObject();
}


// WEBPACK FOOTER //
// ./src/helper/VueHelper.js